export default "__VITE_ASSET__BZK4fF6n__"